import { ReactElement } from "react";
import Modify from "@shared/FormTemplates/Modify";
import ModifyForm from "./ModifyForm";
import updateItem from "@services/Clients/Hackatao/mainAvatars/updateItem";
import validator from "@validators/Clients/Hackatao/mainAvatars/MainAvatars.validate";
import formMapper from "@mappers/Clients/Hackatao/mainAvatars/MainAvatars.mapper";
import useGetMainAvatars from "@hooks/Clients/Hackatao/mainAvatars/useGetMainAvatars";

const ModifyItem = (): ReactElement => (
  <Modify
    CustomForm={ModifyForm}
    modifyHook={updateItem}
    detailHook={useGetMainAvatars}
    validator={validator}
    formMapper={formMapper}
  />
);

export default ModifyItem;
